// Helper de vérification de permissions. Un global admin a tout par défaut.
export const hasPermission = (perms, name) =>
  perms?.isGlobalAdmin || (perms?.permissions || []).includes(name);
